module.exports = __webpack_public_path__ + "static/media/logo-small.ff3164fc.png";